import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

// Hängt das JWT an jede API-Anfrage, damit alle geschützten Endpunkte den Benutzer erkennen
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      console.log('Token found in localStorage, attempting to fetch user data.');
      axios.get('/api/user', {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        console.log('User data fetched successfully:', response.data.user);
      
        setUser(response.data.user);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
        setUser(null);
        setLoading(false);
      });
    } else {
      console.log('No token found in localStorage.');
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      console.log('Attempting to log in with email:', email);
      const response = await axios.post('/api/login', { email, password });
      console.log('Login successful, received token:', response.data.token);
  
      localStorage.setItem('token', response.data.token);
      const userResponse = await axios.get('/api/user', {
        headers: { Authorization: `Bearer ${response.data.token}` }
      });
  
      const loggedInUser = userResponse.data.user;
      const isPending = userResponse.data.pending;
      console.log('ha', isPending);
      console.log('User data after login:', loggedInUser);
      setUser(loggedInUser);
  
      // Prüfen, ob der Benutzer auf die Passwortänderungsseite gehen muss
      if (loggedInUser.hastochange === 1) {
        console.log('User is required to change password, redirecting to /change-password.');
        return '/change-password';
      }
  
      // Falls der Benutzer als "pending" markiert ist, leite auf /pending um
      if (isPending) {
        console.log('User has no team assigned, redirecting to /pending.');
        return '/pending';
      }
  
      console.log('User has team assigned, redirecting to /user.');
      return '/user';
    } catch (error) {
      console.error('Login error:', error);
      return null;
    }
  };
  

  const logout = async () => {
    console.log('Logging out user.');
    localStorage.removeItem('token');
    setUser(null);
    return '/login';
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
